import { render } from "./BaseBottomSheet.vue?vue&type=template&id=32cb3b13&scoped=true"
import script from "./BaseBottomSheet.vue?vue&type=script&lang=js"
export * from "./BaseBottomSheet.vue?vue&type=script&lang=js"

import "./BaseBottomSheet.vue?vue&type=style&index=0&id=32cb3b13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cb3b13"]])

export default __exports__